import React, { useEffect, useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import faradayApi from "../../Services/faradayApi";
import {
  EncargosAccordion,
  EncargosProps,
  ProjectionPeriod,
} from "./EncargosAccordion";

export function TaxHistorySection({
  measuringPointIds,
}: {
  measuringPointIds: string[];
}) {
  const unitsKey = JSON.stringify([...measuringPointIds].sort());
  return <TaxHistoryQuery key={unitsKey} unitsKey={unitsKey} />;
}

function TaxHistoryQuery({ unitsKey }: { unitsKey: string }) {
  const [period, setPeriod] = useState<ProjectionPeriod>();
  const [history, setHistory] = useState<EncargosProps>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    const load = async () => {
      try {
        const response = await faradayApi.post<EncargosProps>(
          "month-data/tax-history",
          {
            measuringPointsIds: JSON.parse(unitsKey),
            monthsToGet: 12,
            ...(period
              ? { projectionMonth: period.month, projectionYear: period.year }
              : {}),
          }
        );
        if (active) setHistory(response.data);
      } catch (error) {
        if (active) {
          console.error("Erro ao carregar histórico de encargos", error);
          setError(true);
        }
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => {
      active = false;
    };
  }, [unitsKey, period, attempt]);

  return (
    <>
      {error && (
        <Alert variant="danger">
          Não foi possível carregar o histórico de encargos.{" "}
          <Button
            variant="outline-danger"
            onClick={() => setAttempt(attempt + 1)}
          >
            Tentar novamente
          </Button>
        </Alert>
      )}
      {loading && (
        <div role="status">
          <Spinner animation="border" size="sm" /> Carregando encargos...
        </div>
      )}
      {history && (
        <EncargosAccordion
          data={history}
          loading={loading}
          onProjectionPeriodChange={setPeriod}
        />
      )}
    </>
  );
}
